import FeaturedIcon from 'components/FeaturedIcon';
import SearchIcon from 'components/icons/Search';
import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  padding-top: 5rem;
`;

const NoMentorship: FC = () => {
  return (
    <Container>
      <FeaturedIcon icon={<SearchIcon />} />
      <p>Aucun mentor ne vous a été associé pour le moment.</p>
    </Container>
  );
};

export default NoMentorship;
